import React from 'react';
import PropTypes from 'prop-types';
import { StringHelper, _ } from '../../strings';

class LanguageBar extends React.Component {

	constructor(props){
        super(props)

        const nowValue = StringHelper.getLocale()
        var items = [
				{text: "English", value: "en", selected: "false", autoSelected: "false"},
				{text: "中文(台灣)", value: "zh",selected: "false", autoSelected: "false"},
				{text: "日本語", value: "ja",selected: "false", autoSelected: "false"},
			];

		var foundSelectedIndex = 0;

		for(var i = 0; i < items.length; i++){
			if(items[i].value == nowValue){
				items[i].selected = "true"
				foundSelectedIndex = i
				if(StringHelper.getUserSelectedLocale() != null){
					items[i].autoSelected = "false"
				}else{
					items[i].autoSelected = "true"

				}
				break;
			}
		}

		var defaultClosed = false
		if(window.innerWidth < 768){
			defaultClosed = true
		}

		this.state = {
			languageItems: items,
			selectedIndex: foundSelectedIndex,
			closed: defaultClosed,
		}
    }

    languageHandlerDidClicked(){
    	this.setState({closed: !this.state.closed})


    }

	languageDidClicked (e) {
		var value = e.props.value
		console.log(e, value)

		var items = this.state.languageItems
		var oldSelectedIndex = this.state.selectedIndex

		var isUncheck = false

		for(var i = 0; i < items.length; i ++){
			items[i].selected = "false"
		}

		var foundSelectedIndex = 0

		for(var i = 0; i < items.length; i ++){
			if(items[i].value == value){
				console.log("found selectedIndex: " + foundSelectedIndex)
				foundSelectedIndex = i
				break;
			}
		}



		if(foundSelectedIndex == oldSelectedIndex) {
		// 	// unchecked or checked?
			if(items[oldSelectedIndex].autoSelected == "true"){
				// fixed it
				items[oldSelectedIndex].autoSelected = "false"
			}else{
				// unfixed it and check default value
				isUncheck = true
				value = StringHelper.getDefaultLocale()

				for(var i = 0; i < items.length; i ++){
					if(items[i].value == value){
						console.log("found selectedIndex: " + foundSelectedIndex)
						foundSelectedIndex = i
						break;
					}
				}

				items[foundSelectedIndex].autoSelected = "true"


			}
		}

		items[foundSelectedIndex].selected = "true"

		this.setState({
			languageItems: items,
			selectedIndex: foundSelectedIndex,
		})

		if(isUncheck){
			StringHelper.setUserSelectedLocale(null)
		}else{
			StringHelper.setUserSelectedLocale(value)
		}

		if(typeof this.props.onChange == "function") {
			if(isUncheck){
				this.props.onChange(StringHelper.getDefaultLocale(), isUncheck)	
			}else{
				this.props.onChange(value, isUncheck)
			}
		}
	}

	updateHead() {
		document.title = _("html_title")
		document.getElementsByName("description")[0].content = _("html_description")
	}

	render () {
		this.updateHead()
		const list = this.state.languageItems.map((it) => {
			return (
					<LanguageItem key={it.value} {...it} onClick={this.languageDidClicked.bind(this)} />
				)


		} )

		var closed = ""
	    if(this.state.closed == true){
	    	closed = "closed"
	    }else{
	    	closed = "opening"
	    }

		return (
			<div className={"language-bar"}>
				<div className={"language-bar-inner " + closed}>
					<div className={"language-bar-button"} onClick={this.languageHandlerDidClicked.bind(this)}>
						<div className={"language-bar-button-image"} >
						</div>
					</div>
					<div className={"language-bar-item-block"}>
						{list}
					</div>
				</div>
			</div>
			)
	}


}


class LanguageItem extends React.Component {


	constructor(props){
        super(props)

        this.state = {
        	selectedType: "unselected",
        }
        if(this.props.selected == "true"){
        	if(this.props.autoSelected == "true"){
        		this.state.selectedType = "auto-selected"	
        	}else{
        		this.state.selectedType = "manual-selected"
        	}
        }



    }

    static getDerivedStateFromProps(nextProps, prevState) {
    	console.log("getDerivedStateFromProps")

    	if(prevState.selectedType == "unselected") {
    		if(nextProps.selected == "false"){
    			return null
    		}

    		if(nextProps.autoSelected == "true"){
    			return {selectedType: "auto-selected"}
    		}else{
    			return {selectedType: "manual-selected"}
    		}
    	}else if(prevState.selectedType == "auto-selected"){
    		if(nextProps.selected == "false"){
    			return {selectedType: "unselected"}
    		}
    		if(nextProps.autoSelected == "false") {
    			return {selectedType: "manual-selected"}
    		}
    	}else if(prevState.selectedType == "manual-selected"){
    		if(nextProps.selected == "false"){
    			return {selectedType: "unselected"}
    		}
    		if(nextProps.autoSelected == "true") {
    			return {selectedType: "auto-selected"}
    		}
    	}

	  // Return null to indicate no change to state.

	  return null
	}

    onClick() {
    	console.log("c " + this.props.onClick)
    	if(typeof this.props.onClick == 'function'){
    		this.props.onClick(this)
    	}
    }


	render () {
		var selectedType = this.state.selectedType
		return (
				<div className="language-bar-item" onClick={this.onClick.bind(this)}>
					<div className="language-bar-item-text">
						{this.props.text}
					</div>
					<span className={"language-bar-item-underline " + selectedType}></span>
				</div>
			)
	}
}



LanguageItem.propTypes = {
	text: PropTypes.string.isRequired,
	selected: PropTypes.string,
	autoSelected: PropTypes.string,
}


export default LanguageBar;